var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-wrap"},[_c('router-view',{staticClass:"home-view"}),_vm._v(" "),_c('nav-bar',{directives:[{name:"show",rawName:"v-show",value:(_vm.showTab),expression:"showTab"}],staticClass:"nav-tabs",attrs:{"tabs":_vm.tabs}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78fb0f1a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/index.vue
// module id = null
// module chunks = 